export enum OpportunityType {
    PENDING = 1,
    COMPONENT,
    ACTIVE,
    CLOSED_STILL_OPP,
    NO_GOAL,
    CLOSED_NOT_OPP,
    MISSED,
    MISSED_EXPIRED,
}
